module.exports = {
  media: {
    badge: "Test",
    title: "Ornek",
    subtitle: "Test ornek",
    summaryTitle: "Test",
    summaryText: "Ornek",
    summaryPoints: ["Test", "Ornek", "Test"],
    cardsTitle: "Test",
    cardsSubtitle: "Ornek",
    cards: [
      { icon: "fas fa-photo-film", title: "Test", text: "Ornek" },
      { icon: "fas fa-file-powerpoint", title: "Ornek", text: "Test" },
      { icon: "fas fa-folder-open", title: "Test", text: "Ornek" }
    ],
    listTitle: "Test",
    listSubtitle: "Ornek",
    listItems: ["Test", "Ornek", "Test"],
    stats: [
      { value: "Test", label: "Ornek" },
      { value: "Ornek", label: "Test" }
    ],
    ctaTitle: "Test",
    ctaText: "Ornek",
    primaryHref: "/pages/contact",
    primaryLabel: "Test",
    secondaryHref: "/pages/services",
    secondaryLabel: "Ornek",
    filterAriaLabel: "Test",
    modalCloseLabel: "Test",
    modalTitle: "Ornek",
    modalDescription: "Test",
    filters: [
      { key: "all", label: "Test", icon: "fas fa-th" },
      { key: "photo", label: "Ornek", icon: "fas fa-image" },
      { key: "video", label: "Test", icon: "fas fa-video" }
    ],
    items: [
      { type: "video", icon: "fas fa-play-circle", placeholder: "Test", title: "Ornek", description: "Test", badge: "Ornek", badgeIcon: "fas fa-video", playLabel: "Test" },
      { type: "photo", icon: "fas fa-image", placeholder: "Ornek", title: "Test", description: "Ornek", badge: "Test", badgeIcon: "fas fa-image" },
      { type: "video", icon: "fas fa-play-circle", placeholder: "Test", title: "Ornek", description: "Test", badge: "Ornek", badgeIcon: "fas fa-video", playLabel: "Test" },
      { type: "photo", icon: "fas fa-image", placeholder: "Ornek", title: "Test", description: "Ornek", badge: "Test", badgeIcon: "fas fa-image" },
      { type: "photo", icon: "fas fa-image", placeholder: "Test", title: "Ornek", description: "Test", badge: "Ornek", badgeIcon: "fas fa-image" },
      { type: "video", icon: "fas fa-play-circle", placeholder: "Ornek", title: "Test", description: "Ornek", badge: "Test", badgeIcon: "fas fa-video", playLabel: "Test" }
    ]
  }
};